import { API } from '@/api/Api'

import { GetBankAssumptions } from '@/api/query/Assumptions.graphql'

export default {
  // Mutations
  async GetBankAssumptions (accountId, analysisId, liquidityParametersId) {
    const Data = { accountId: accountId, analysisId: analysisId, liquidityParametersId: liquidityParametersId }
    return await API.GQLRequest(GetBankAssumptions, Data)
  }
}
